import { render, staticRenderFns } from "./qaManage.vue?vue&type=template&id=8fb6dbf6&scoped=true&"
import script from "./qaManage.vue?vue&type=script&lang=js&"
export * from "./qaManage.vue?vue&type=script&lang=js&"
import style0 from "./qaManage.vue?vue&type=style&index=0&id=8fb6dbf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fb6dbf6",
  null
  
)

export default component.exports